<app-navbar></app-navbar>

<div class="dashboard-full-width">
    <div class="">
        <div class="main-container-dashboard">


            <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->

            <div class="dashboard-container-right">
                <div class="main-container">
                    <div class="row">
                        <div class="card shadow m-5" style="width: 100%">
                            <div class="card-header header-dashboard-button-2">
                                <h4>Sample Center Employees</h4>
                                <!-- <button class="small-btn-dash" (click)="viewAddCenter(addCenterModal)"> Add Center <i
                      class="far fa-plus-square"></i></button> -->
                                <button class="small-btn-dash" (click)="viewAddEmployee(addEmployeeModal)">Add
                                    Employee</button>
                            </div>
                            <div class="card-body">


                                <div class="col-lg-12 ">

                                    <div class=" p-5 d-flex justify-content-center">
                                        <div class="table-responsive">
                                            <table
                                                class="table table-bordered table-condensed table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
                                                datatable [dtOptions]="dtOptions" width="100%">
                                                <thead class="">
                                                    <tr>
                                                        <th scope="col">S/N</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Email Address</th>
                                                        <th scope="col">Phone Number</th>
                                                        <th scope="col">Sample Center</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="dashboard-bg-white">
                                                    <tr>
                                                        <th scope="row">1</th>
                                                        <td>Waelchi, Hane and Schoen</td>
                                                        <td>qwert@wer.com</td>
                                                        <td>09876543234</td>
                                                        <td>Center 4</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">2</th>
                                                        <td>Waelchi, Hane and Schoen</td>
                                                        <td>qwert@wer.com</td>
                                                        <td>09876543234</td>
                                                        <td>Center 4</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">3</th>
                                                        <td>Waelchi, Hane and Schoen</td>
                                                        <td>qwert@wer.com</td>
                                                        <td>09876543234</td>
                                                        <td>Center 4</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">4</th>
                                                        <td>Waelchi, Hane and Schoen</td>
                                                        <td>qwert@wer.com</td>
                                                        <td>09876543234</td>
                                                        <td>Center 4</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
</div>




<ng-template #addEmployeeModal let-modal>
    <div class="card col-lg-12 mb-5">
        <div class="row">

            <div class="card-header col-lg-12  header-dashboard-button-2">
                <h3>Add Employee</h3>
                <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
            </div>

            <div class="card-body p-4">
                <form [formGroup]="addEmployeeForm" (ngSubmit)="onSubmitEmployee(addEmployeeForm.value)">
                    <div class="row">

                        <div class="col-md-6 mt-3">
                            <label class="form-label">Name Of Employee<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>

                            <input type="text" class="form-control" id="name" formControlName="name" placeholder=""
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.name.errors }">


                            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.name.errors"
                                class="form-text text-danger">
                                <div *ngIf="addEmployeeForm.controls.name.errors.required">Employee Name is required
                                </div>
                                <div *ngIf="addEmployeeForm.controls.name.errors.maxlength"> Employee Name must be under
                                    45
                                    characters
                                </div>
                                <div *ngIf="addEmployeeForm.controls.name.errors.pattern">Employee Name must be only
                                    alphabets</div>
                            </div>

                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Email Address<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>
                            <input type="email" class="form-control" formControlName="emailAddress" id="emailAddress"
                                aria-describedby="emailHelp"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.emailAddress.errors }"
                                placeholder="">
                            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.emailAddress.errors"
                                class="form-text text-danger">
                                <div *ngIf="addEmployeeForm.controls.emailAddress.errors.required">Email is required
                                </div>
                                <div *ngIf="addEmployeeForm.controls.emailAddress.errors.pattern">Please enter a valid
                                    email
                                </div>
                                <div *ngIf="addEmployeeForm.controls.emailAddress.errors.maxlength">Email must be under
                                    45
                                    characters
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Password<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>
                            <input type="password" class="form-control" id="password" maxlength="15"
                                formControlName="password"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.password.errors }"
                                placeholder="">
                            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.password.errors"
                                class="form-text text-danger">
                                <div *ngIf="addEmployeeForm.controls.password.errors.required">Password is required
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Confirm Password<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>
                            <input type="text" class="form-control" formControlName="confirmPassword" placeholder=""
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.confirmPassword.errors }">
                            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.confirmPassword.errors"
                                class="form-text text-danger">
                                <div *ngIf="addEmployeeForm.controls.confirmPassword.errors.required">Confirm Password
                                    is
                                    required</div>
                            </div>
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Sample Center<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>
                            <select type="text" class="form-control" formControlName="sampleCenter" placeholder=""
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.sampleCenter.errors }">
                                <option value="">Center 1</option>
                                <option value="">Center 2</option>
                                <option value="">Center 3</option>
                            </select>
                            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.sampleCenter.errors"
                                class="form-text text-danger">
                                <div *ngIf="addEmployeeForm.controls.sampleCenter.errors.required">Samle Center is
                                    required</div>
                            </div>
                        </div>

                        <div class="col-md-4 mt-5 text-center"><button type="submit"
                                class="btn btn-secondary  theme-btn-2 dropdown-toggle-no">Submit</button>
                        </div>



                    </div>
                </form>

            </div>

        </div>




    </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>